import Loadable from '@townsquare/loadable';
import { SiteHomePageRoute, GlobalHomePageRoute } from '@townsquare/router/route-types';
import { goalSettingsRoute } from '@townsquare/routes/goal-settings';
import { projectSettingsRoute } from '@townsquare/routes/project-settings';
import { noWorkspacePersonalSettingsRoute, settingsRoute } from '@townsquare/routes/settings-view';

import { goalAccessPermissionsSettingsResource } from './resources/agg/goalAccessPermissionsSettings';
import { projectAccessPermissionsSettingsResource } from './resources/agg/projectAccessPermissionsSettings';
import { goalSettingsPageResource } from './resources/goalSettings';
import { noWorkspacePersonalSettingsPageResource } from './resources/noWorkspacePersonalSettings';
import { projectSettingsPageResource } from './resources/projectSettings';
import { settingsPageResource } from './resources/settings';

// Settings View
const SettingsViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "settings-view" */ './components/SettingsView'),
	loading: () => null,
});

settingsRoute.component = SettingsViewLoadable;
settingsRoute.resources = [settingsPageResource];
export const settingsRouterRoute: SiteHomePageRoute = settingsRoute;

// No Workspace Personal Settings View
const NoWorkspacePersonalSettingsViewLoadable = Loadable({
	loader: () =>
		import(/* webpackChunkName: "settings-view" */ './components/NoWorkspacePersonalSettingsView'),
	loading: () => null,
});

noWorkspacePersonalSettingsRoute.component = NoWorkspacePersonalSettingsViewLoadable;
noWorkspacePersonalSettingsRoute.resources = [noWorkspacePersonalSettingsPageResource];
export const noWorkspacePersonalSettingsRouterRoute: GlobalHomePageRoute =
	noWorkspacePersonalSettingsRoute;

// Goal Settings View
const GoalSettingsViewLoadable = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "goal-settings-view" */ './components/GoalSettings/GoalSettingsView'
		),
	loading: () => null,
});

goalSettingsRoute.component = GoalSettingsViewLoadable;
goalSettingsRoute.resources = [goalSettingsPageResource, goalAccessPermissionsSettingsResource];
export const goalSettingsRouterRoute: GlobalHomePageRoute = goalSettingsRoute;

// Project Settings View
const ProjectSettingsViewLoadable = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "project-settings-view" */ './components/ProjectSettings/ProjectSettingsView'
		),
	loading: () => null,
});

projectSettingsRoute.component = ProjectSettingsViewLoadable;
projectSettingsRoute.resources = [
	projectSettingsPageResource,
	projectAccessPermissionsSettingsResource,
];
export const projectSettingsRouterRoute: GlobalHomePageRoute = projectSettingsRoute;
